import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Customer } from '../domain/customer';

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient) {}

    getCustomersSmall() {
        return this.http
            .get<any>("assets/demo/data/customers-small.json")
            .toPromise()
            .then((res) => res.data as Customer[])
            .then((data) => data);
    }

    getCustomersMedium() {
        return this.http
            .get<any>("assets/demo/data/customers-medium.json")
            .toPromise()
            .then((res) => res.data as Customer[])
            .then((data) => data);
    }

    getCustomersLarge() {
        return this.http
            .get<any>("assets/demo/data/customers-large.json")
            .toPromise()
            .then((res) => res.data as Customer[])
            .then((data) => data);
    }

    getQueuesData(): Promise<any[]> {
        return this.http
            .get<any>("assets/demo/data/queue.json")
            .toPromise()
            .then((res) => <any[]>res.data)
            .then((data) => {
                return data;
            });
    }
    getUsersData(): Promise<any[]> {
        return this.http
            .get<any>("assets/demo/data/users.json")
            .toPromise()
            .then((res) => <any[]>res.data)
            .then((data) => {
                return data;
            });
    }

    getPackagesLarge() {
        return this.http
            .get<any>("assets/demo/data/package.json")
            .toPromise()
            .then((res) => res.data as any[])
            .then((data) => data);
    }

    getCustomersMixed() {
        return this.http
            .get<any>("assets/demo/data/customers-mixed.json")
            .toPromise()
            .then((res) => res.data as Customer[])
            .then((data) => data);
    }
}
